// extracted by mini-css-extract-plugin
export default {"zoomControls":"pea-z","zoomControlButton":"qea-z","zoomBanner":"rea-z","bannerButton":"sea-z","imageButton":"tea-z","zoom":"uea-z","zoomContent":"vea-z"};